import { useEffect, useRef, useState } from "react";

interface InViewOptions {
  threshold?: number;
  rootMargin?: string;
  root?: Element | null;
}

export function useInView<T extends HTMLElement = HTMLDivElement>(
  options?: InViewOptions
) {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setInView(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px", ...options }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [options]);

  return { ref, inView };
}